/**
 * Observability Bootstrap
 *
 * Initialize observability as early as possible in the application lifecycle.
 * This module should be imported at the top of main.tsx before any other code.
 */

import { initObservability } from "./adapter"
import { installGlobalErrorHandlers } from "./globalHandlers"
import { installDevTools } from "./devTools"
import { env } from "@/lib/env"

/**
 * Initialize observability based on environment configuration.
 * Returns a promise that resolves when initialization is complete.
 */
export async function bootstrapObservability(): Promise<void> {
  await initObservability({
    provider: env.VITE_OBS_PROVIDER,
    dsn: env.VITE_OBS_DSN,
    environment: env.VITE_ENVIRONMENT,
    release: env.VITE_RELEASE,
    service: "frontend",
    debug: import.meta.env.DEV,
  })

  // Install global error handlers after initialization
  installGlobalErrorHandlers()

  // Install dev tools (no-op in production)
  installDevTools()
}
